import {
    FormSection,
    FormTitleWrapper,
    SubmittedBanner,
    SubmittedSubtitle,
    SubmittedTitle,
} from '../custom-styles/FormSection.styles';

import COLORS from 'shared/config/colors';
import CircularProgress from '@material-ui/core/CircularProgress';
import EditIcon from '@material-ui/icons/Edit';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import React from 'react';
import PropTypes from 'prop-types';
import Text, { VARIANTS } from 'shared/components/data-display/text/Text';

function FormSectionStatus({ isTimesheetSubmittedLoading, isTimesheetSubmitted }) {
    if (isTimesheetSubmittedLoading) {
        return (
            <FormSection>
                <FormTitleWrapper>
                    <EditIcon />
                    <Text variant={VARIANTS.Headline_4} color={COLORS.Black}>
                        Time Entry
                    </Text>
                </FormTitleWrapper>
                <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
                    <CircularProgress size={20} thickness={4} style={{ color: '#9ca3af' }} />
                </div>
            </FormSection>
        );
    }

    if (isTimesheetSubmitted) {
        return (
            <FormSection>
                <FormTitleWrapper>
                    <EditIcon />
                    <Text variant={VARIANTS.Headline_4} color={COLORS.Black}>
                        Time Entry
                    </Text>
                </FormTitleWrapper>
                <SubmittedBanner>
                    <LockOutlinedIcon />
                    <SubmittedTitle>Timesheet submitted</SubmittedTitle>
                    <SubmittedSubtitle>
                        You've already submitted your timesheet for this week.<br />
                        Time entries are locked until it's reopened.
                    </SubmittedSubtitle>
                </SubmittedBanner>
            </FormSection>
        );
    }

    return null;
}

FormSectionStatus.propTypes = {
    isTimesheetSubmittedLoading: PropTypes.bool,
    isTimesheetSubmitted: PropTypes.bool,
};

export default FormSectionStatus;
